import React, { useState, useEffect, useContext, useMemo } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, ListSubheader, MenuItem, Select, Slide } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';

import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";

import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import FileInput from "components/FileInput";

import moment from "moment";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

export default function FileUploadsDialog({ openModal, handleClose, getUserUploads, availableUploadTypes }) {
    const { companyId } = useContext(PrivateRoutesContext);
    const [uploadTypes, setUploadTypes] = useState([]);
    const [uploadType, setUploadType] = useState("");
    const [closedPayPeriods, setClosedPayPeriods] = useState([]);
    const [currentOpenPayPeriods, setCurrentOpenPayPeriods] = useState([]);
    const [acceptedFileExtensions, setAcceptedFileExtensions] = useState("");
    const [isPayPeriodRequired, setIsPayPeriodRequired] = useState(false);
    const [payPeriod, setPayPeriod] = useState("infile");
    const [file, setFile] = useState(null);
    const [fileInputRef, setFileInputRef] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
  
    const fileInfo = {
      file,
      setFile,
      fileInputRef,
      setFileInputRef,
    };

    useEffect(() => {
      apiGet(apiUrls.getUploadTypes).then(
        (response) => {
          console.log('files types',response.data)
          if(availableUploadTypes==null || availableUploadTypes.length==0){
            setUploadTypes(response.data);
          }
          else{
            console.log('files types',response.data)
            console.log('availableUploadTypes',availableUploadTypes)
            setUploadTypes(response.data.filter((u) => {return availableUploadTypes.map(a => a.toLowerCase()).includes(u.uploadTypeID)}));
            if(availableUploadTypes.length==1){
              setUploadType(availableUploadTypes[0]);
            }
          }
        }
      );
    },[]);

    useEffect(() => {
      if(companyId != null && companyId.length > 0){
        apiGet(apiUrls.getCompanyDropdowns(companyId)).then(
          (response) => {
            setClosedPayPeriods(response.data.closedPayPeriods);
          }
        );
  
        apiGet(apiUrls.getOpenPayDatesDropdown(companyId)).then(
          (response) => {
            setCurrentOpenPayPeriods(response.data);
          }
        );
      }
    },[companyId]);

    useEffect(() => {
      if (openModal) {
        setUploadType("");
        setPayPeriod("infile");
        setFile(null);
        setFileInputRef(prev => { prev.value = ""; return prev; })
      }
    },[openModal]);

    const handleSubmit = async (e) => {
      setIsSubmitting(true);
      
      // await will not continue until after uploadFile
      let res = await uploadFile(file);
  
      setIsSubmitting(false);
      handleClose();
      
      if (getUserUploads) {
        getUserUploads(companyId);
      }
    };
  
    const uploadFile = async (file) => {
      const formData = new FormData();
      formData.append("file", file);
  
      let payPeriodParameter = payPeriod;
      if (payPeriod === "infile") {
        payPeriodParameter = null;
      }

      let isRetro = closedPayPeriods.indexOf(payPeriod) > -1;

      return apiPost(apiUrls.uploadFile(companyId, uploadType, payPeriodParameter, isRetro), formData, {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "*/*",
        },
      });
    };

    useEffect(() => {
      let selectedUploadType = uploadTypes.find(u => u.uploadTypeID === uploadType);

      setIsPayPeriodRequired(false);
      if (selectedUploadType) {
        setIsPayPeriodRequired(selectedUploadType.doShowPayPeriod);
        if (selectedUploadType.doShowPayPeriod) {
          setPayPeriod("infile");
        }
  
        setAcceptedFileExtensions(selectedUploadType.fileExtensions);
      }
    },[uploadType])

    return (
        <Dialog
          open={openModal}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
          className={TableStyle.fileTypeModalWrapper}
          fullWidth
        >
          <DialogTitle id="alert-dialog-slide-title">
            {"File Upload"}
          </DialogTitle>
          <DialogContent>
            {/* SELECT UPLOAD TYPE */}
            <FormControl className={TableStyle.payperiodDropdownWrapper}>
              <InputLabel id="demo-simple-select-outlined-label">
                Select Upload Type
              </InputLabel>
              <Select
                variant="standard"
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={uploadType}
                onChange={e => setUploadType(e.target.value)}
                label="Select Upload Type"
              >
                <MenuItem key={-1} value={""}>Select a value</MenuItem>
                {uploadTypes.map((item, i) => {
                  return(<MenuItem key={i} value={item.uploadTypeID}>{item.uploadTypeName}</MenuItem>);
                })}
              </Select>
            </FormControl>

            {/* SELECT PAY PERIOD */}
            {isPayPeriodRequired ? (
              <div className="mt-2">
                <FormControl className={TableStyle.payperiodDropdownWrapper}>
                  <InputLabel id="pay-period-dropdown">
                    Pay Period
                  </InputLabel>
                  <Select
                    variant="standard"
                    labelId="pay-period-dropdown"
                    value={payPeriod}
                    onChange={e => setPayPeriod(e.target.value)}
                    label="Pay Period"
                  >
                    <MenuItem key={0} value={"infile"}>Pay Date Included in File</MenuItem>
                    <ListSubheader>Open Pay Dates</ListSubheader>
                    {currentOpenPayPeriods.map((item, i) => { 
                      return(<MenuItem key={i+1} value={item}>{moment(item).format('MMMM DD, YYYY')}</MenuItem>);
                    })}
                    <ListSubheader>Closed Pay Dates</ListSubheader>
                    {closedPayPeriods.map((item, i) => {
                      return(<MenuItem key={currentOpenPayPeriods.length+i+2} value={item}>{moment(item).format('MMMM DD, YYYY')}</MenuItem>);
                    })}
                  </Select>
                </FormControl>
              </div>
            ) : (
              <></>
            )}

            {/* UPLOAD FILE */}
            <FileInput acceptedFileExtensions={acceptedFileExtensions} fileInfo={fileInfo} />
          </DialogContent>
          <DialogActions className={ButtonStyle.buttonWrapper}>
              <LoadingButton
                loading={isSubmitting}
                loadingPosition="start"
                startIcon={<PublishOutlinedIcon />}
                onClick={handleSubmit}
                className={ButtonStyle.CsubmitBtn}
                variant="outlined"
                disabled={uploadType === "" || file === null || file === undefined}
              >
                Upload File
              </LoadingButton>
            <Button variant="outlined" onClick={handleClose} className={ButtonStyle.CcancelBtn} disabled={isSubmitting}>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
    )
}